<div class="outer-container"> 
          <!-- Audit Trails Section Section -->
  <div >
    <div class="header-row p-2 d-flex align-items-center justify-content-end mb-0" 
         id="audit-trails_div_headeractions">
      <app-grid-actions
        id="audit-trails_grid_actions"
        [actions]="auditTrailsSection.gridActions"
        [showColumnChooser]="auditTrailsSection.showColumnChooser"
        [allColumns]="auditTrailsSection.allColumns"
        [visibleColumns]="auditTrailsSection.visibleColumns"
        (exportClick)="onAuditTrailsExport()"
        (columnChooserToggle)="onAuditTrailsColumnChooserToggle()"
        (columnToggle)="onAuditTrailsColumnToggle($event)"
        (columnChooserClose)="onAuditTrailsColumnChooserClose()">
      </app-grid-actions>
    </div>
    <app-data-grid  #auditTrailsGrid   [config]="auditTrailsSection.dataGridConfig" [statusDataField]="'strStatus'" id="audit_trails_grid_datagrid">
      <ng-template #actionsTemplate let-data let-rowIndex="index">
        <div class="action-buttons-container d-flex gap_action"
            [id]="'audit_trails_grid_div_actionbuttons_' + index">
            <span class="action-span-wrapper view-wrapper" >
                <button type="button" (click)="$event.stopPropagation(); viewTemplate(data)" matTooltipClass="custom-tooltip"
                    class="action-icon-button" matTooltip="View" matTooltipPosition="above">
                    <img src="assets/images/neveda-images/eye.svg" alt="" width="20" height="20" aria-hidden="true"/>
                </button>
            </span>
        </div>
    </ng-template>
    </app-data-grid>
  </div>
</div>